<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="page-header">

    <div class="header-left">
        <h1>My Stalls</h1>
        <p>Manage stalls, products, users and rewards</p>
    </div>

    <div class="header-right">

        <div class="search-box">
            <mat-icon>search</mat-icon>

            <input type="text" placeholder="Search stall..." (keyup)="applyFilter($event)">
        </div>

        <!-- <button mat-stroked-button class="redeem-btn">

            <mat-icon>redeem</mat-icon>
            Requests

        </button> -->

        <button mat-flat-button color="primary" (click)="createEventStall()">

            <mat-icon>add</mat-icon>
            Add Stall

        </button>

    </div>

</div>

<!-- Search -->


<!-- Cards -->

<div class="stall-grid">

    <mat-card class="stall-card" *ngFor="let stall of filteredStalls">

        <!-- Header -->

        <div class="card-header">

            <div>

                <div class="stall-number">
                    Stall {{ stall.stall_num }}
                </div>

                <div class="company-name">
                    {{ stall.company_name }}
                </div>

            </div>

            <button mat-icon-button [matMenuTriggerFor]="menu">

                <mat-icon>more_vert</mat-icon>

            </button>

            <mat-menu #menu="matMenu">

                <!-- <button mat-menu-item (click)="editMyStall(stall.so_id)">

                    <mat-icon>edit</mat-icon>
                    <span>Manage Stall</span>

                </button> -->

                <button mat-menu-item (click)="openLink(stall.so_id)">

                    <mat-icon>share</mat-icon>
                    <span>Share Catalogue</span>

                </button>

            </mat-menu>

        </div>

        <!-- Website -->

        <div class="website" *ngIf="stall.website">

            <mat-icon>language</mat-icon>

            <span>
                {{ stall.website }}
            </span>

        </div>

        <!-- Redeem Banner -->

        <div class="redeem-banner" (click)="goToRedeemRequests(stall.so_id)">

            <div class="redeem-left">

                <mat-icon class="redeem-icon">
                    redeem
                </mat-icon>

                <div>

                    <div class="banner-title">
                        Redeem Requests
                    </div>

                    <div class="banner-subtitle">
                        Review pending reward claims
                    </div>

                </div>

            </div>

            <div class="redeem-right">

                <span class="request-count">
                    {{ stall.total_requests || 0 }}
                </span>

                <mat-icon class="arrow-icon">
                    chevron_right
                </mat-icon>

            </div>

        </div>

        <!-- Quick Actions -->

        <div class="action-grid">

            <div class="action-tile" (click)="goToCategory(stall.so_id)">

                <mat-icon>category</mat-icon>

                <span>Categories</span>

            </div>

            <div class="action-tile" (click)="goToProduct(stall.so_id)">

                <mat-icon>inventory_2</mat-icon>

                <span>Products</span>

            </div>

            <div class="action-tile" (click)="goToInquiry(stall.so_id)">

                <mat-icon>forum</mat-icon>

                <span>Leads</span>

            </div>

            <div class="action-tile" (click)="openStallUsers(stall.so_id)">

                <mat-icon>groups</mat-icon>

                <span>Users</span>

            </div>

        </div>

        <!-- Footer -->

        <div class="footer-actions">

            <button mat-flat-button color="primary" (click)="editMyStall(stall.so_id)">

                <mat-icon>edit</mat-icon>
                Edit Stall
            </button>

            <button mat-stroked-button (click)="scanReport(stall.so_id)">

                <mat-icon>analytics</mat-icon>
                Analytics

            </button>

        </div>

    </mat-card>

</div>